import { call, put, select, takeLatest } from 'redux-saga/effects'

import { IHateoasLink } from '@store'
import { selectAuthToken } from '@store/auth/selectors'
import { fetchCampaignSuccess, selectCampaignLink } from '@store/campaigns'
import {
  detachTranscript,
  detachTranscriptFailure,
  detachTranscriptSuccess,
} from '@store/discoveryRuns/actions'
import { DETACH_TRANSCRIPT_REL, extractVerbatimErrorMessage } from '@store/discoveryRuns/api'
import { toast } from '@tribegroup'
import { networkRequest } from '@utils/networkRequest'

// BRAND-9582 item 13: mirrors attachTranscriptSaga exactly, except the
// request itself is a body-less PUT (no file to send). Detach is idempotent,
// so no isAlreadyAttachedError-style handling is needed.
export function* detachTranscriptSaga(action: ReturnType<typeof detachTranscript>) {
  const { campaignId } = action.payload
  try {
    const token: string = yield select(selectAuthToken)
    // detach_transcript is a rel on the BRIEF's own top-level `links` (not
    // nested inside the `sourcing` block) — same selector used for every
    // other campaign-scoped HATEOAS action.
    const link: IHateoasLink | undefined = yield select(
      selectCampaignLink,
      campaignId,
      DETACH_TRANSCRIPT_REL,
    )
    if (!link) {
      // Surface the dead-end to the user, not just redux state (review fix
      // pattern, matching attachTranscriptSaga).
      yield put(detachTranscriptFailure("Transcript can't be removed right now."))
      yield call(toast, "Transcript can't be removed right now.")
      return
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = yield call(networkRequest, link.method, link.href, undefined, token)
    // Success returns the full brief view — refresh the campaign the same
    // way attach does, rather than duplicating its shape. This is the ONLY
    // thing that flips transcript_attached to false; nothing here touches
    // local component state.
    yield put(fetchCampaignSuccess(response))
    yield put(detachTranscriptSuccess())
  } catch (e: any) {
    const message = extractVerbatimErrorMessage(e)
    yield put(detachTranscriptFailure(message))
    yield call(toast, message)
  }
}

export default function* watchDetachTranscript() {
  yield takeLatest(detachTranscript.type, detachTranscriptSaga)
}
